// Imports
import { parsePhoneNumberFromString } from 'libphonenumber-js';


// Format a phone number, using safety guards to prevent errors
export default function formatPhoneNumber(number: string, contextCallingCode: number) {
	// Handle no number at all
	if (!number) {
		return '';
	}
	
	
	// Parse the string version
	const parsedVersion = parsePhoneNumberFromString(number);
	
	
	// Handle if the parsing was successful
	if (typeof parsedVersion === 'object') {
		// Only if `formatNational` is a function
		if (typeof parsedVersion.formatNational === 'function') {
			// Number is domestic
			if (parsedVersion.countryCallingCode === String(contextCallingCode)) {
				return parsedVersion.formatNational();
			}
			
			
			// Number is internationally referencing a North American Number Plan number
			if (parsedVersion.countryCallingCode === '1') {
				return `+1 ${parsedVersion.formatNational()}`;
			}
		}
		
		
		// Only if `formatInternational` is a function
		if (typeof parsedVersion.formatInternational === 'function') {
			// Non-North American Number Plan number
			return parsedVersion.formatInternational();
		}
	}
	
	
	// Handle otherwise
	return number;
}
